<template>
  <ModalAddEditCustomer
    ref="modal"
    v-if="modalShowAddCustomer"
    @closeModal="closeModalAddEditCustomer"
    @openAlertSuccess_CustomerCreated="openAlert_CustomerCreated"
    @openAlertSuccess_CustomerUpdated="openAlert_CustomerUpdated"
    :customerData="customerToEdit"
    :id="customerToEdit?.id"
  />
  <transition name="fade">
    <AlertConfirmation
      v-if="alert_confirmation"
      @confirmNo="handle_clicked_no"
      @confirmYes="handle_clicked_yes"
      :animation_class="animation_alert_confirmation_class"
      title="Delete Customer"
      text="Are you sure you want to delete this Customer?"
      text_class="text-xl font-medium"
    />
  </transition>
  <section class="grid grid-cols-2 lg:grid-cols-4 gap-4 pb-40 h-fit">
    <PageHeader
      class="col-span-2 sm:col-span-1 lg:col-span-2"
      title="Customer"
      subtitle="All Customer"
    />
    <div class="col-span-2 sm:col-span-1 lg:col-span-2 flex justify-end items-end">
      <Button
        button_id="new-customer"
        button_text="&#43; New Customer"
        @click="showModalAddCustomer()"
        class="w-full md:w-auto"
      />
    </div>

    <div class="row-start-2 col-span-2 lg:col-span-2">
      <!-- Branch Selection Filter as a Dropdown with Select Component -->
      <div class="flex gap-2 items-center">
        <!-- <p class="text-sm text-white">Select Branch</p> -->
        <select
          v-model="selectedBranch"
          @change="filterByBranch"
          class="block text-lg mt-1 flex-1 rounded-3xl border-b bg-transparent border-white/50 px-3 py-1 text-white placeholder:text-gray-300 placeholder:text-[12px] sm:text-sm sm:leading-6 focus:outline-none focus:ring-0 focus:shadow-lg focus:shadow-white/70 transition-shadow duration-500"
        >
          <option value="" selected class="text-black">All Branches</option>
          <option
            v-for="(branch, index) in allBranches"
            :key="index"
            :value="branch.id"
            class="text-gray-800 text-sm"
          >
            {{ branch.name }}
          </option>
        </select>

        <!-- Search and Table Section -->
        <InputForm
          placeholder="Search customer name"
          class="p-2 rounded-3xl w-full"
          v-model="searchQuery"
          @input="handleSearch"
        />
      </div>
    </div>

    <Card card_class="col-span-2 lg:col-span-4">
      <AlertSuccess v-if="alert_success" :text="alert_text" />

      <DinamicTable :header_columns="table_header" th_class="text-left">
        <TableRow v-if="filteredCustomer.length <= 0">
          <td
            colspan="7"
            class="p-3 text-center italic text-white tracking-widest"
          >
            ~ No data available ~
          </td>
        </TableRow>
        <TableRow v-for="(customer, index) in filteredCustomer" :key="index">
          <TableCell>{{
            index + 1 + (pagination.page - 1) * pagination.perPage
          }}</TableCell>
          <TableCell>{{ customer?.name }}</TableCell>
          <TableCell>{{ customer?.phone_number ? customer?.phone_number : '-' }}</TableCell>
          <TableCell>{{ customer?.email ? customer?.email : '-' }}</TableCell>
          <TableCell>{{ customer?.birthdate ? formatDate(customer?.birthdate) : '-' }}</TableCell>
          <TableCell>{{ customer.address ? customer?.address : '-' }}</TableCell>
          <TableCell>{{ getBranchName(customer?.branch_id) }}</TableCell>
          <TableCell class="flex gap-2">
            <TableButtonEdit
              path="#"
              :container_id="`btnEditCustomer${customer?.id}`"
              @click="editCustomer(customer)"
            />
            <TableButtonDelete
              @click="deleteCustomer(customer?.id)"
              path="#"
              :container_id="`btnDeleteCustomer${customer?.id}`"
            />
            <TableButtonView
              :path="`customer/detail/${customer?.id}`"
              :container_id="`btnViewCustomer${customer?.id}`"
            />
          </TableCell>
        </TableRow>
      </DinamicTable>
      <Pagination
        :totalItems="currentPagination.totalItems"
        :perPage="parseInt(currentPagination.perPage)"
        :currentPage="parseInt(currentPagination.page)"
        :previousPageLink="currentPagination?.previousPageLink"
        :nextPageLink="currentPagination?.nextPageLink"
        @page-changed="fetchCustomers"
      />
    </Card>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Card from "@/components/organisms/Card.vue";
import PageHeader from "@/components/molecules/PageHeader.vue";
import DinamicTable from "@/components/organisms/DinamicTable.vue";
import Button from "@/components/buttons/Button.vue";
import TableRow from "@/components/atoms/table/TableRow.vue";
import TableCell from "@/components/atoms/table/TableCell.vue";
import TableButtonEdit from "@/components/atoms/table/TableButtonEdit.vue";
import TableButtonDelete from "@/components/atoms/table/TableButtonDelete.vue";
import TableButtonView from "@/components/atoms/table/TableButtonView.vue";
import AlertSuccess from "@/components/alerts/AlertSuccess.vue";
import Pagination from "@/components/organisms/Pagination.vue";
import InputForm from "@/components/form/InputForm.vue";
import ModalAddEditCustomer from "@/components/modals/ModalAddEditCustomer.vue";
import Select from "@/components/form/Select.vue";
import AlertConfirmation from "@/components/alerts/AlertConfirmation.vue";
import { formatDate } from "@/helpers/formating";
import { debounce } from 'lodash';

export default {
  name: "Customers",
  components: {
    PageHeader,
    AlertConfirmation,
    DinamicTable,
    Card,
    Button,
    TableRow,
    TableCell,
    TableButtonEdit,
    TableButtonDelete,
    TableButtonView,
    AlertSuccess,
    Pagination,
    InputForm,
    ModalAddEditCustomer,
    Select,

  },
  data() {
    return {
      table_header: [
        "No",
        "Name",
        "Phone",
        "Email",
        "birthdate",
        "Address",
        "Branch",
        "Action",
      ],
      alert_success: false,
      alert_text: "",
      customerToEdit: null,
      modalShowAddCustomer: false,
      selectedBranch: "",
      searchQuery: "",

      alert_confirmation: false,
      animation_alert_confirmation_class: "",
      customer_id_to_delete: null,
    };
  },
  computed: {
    ...mapGetters("customers", ["allCustomers", "pagination"]),
    ...mapGetters("branches", ["allBranches"]),

    filteredCustomer() {
      return this.allCustomers.filter((customer) => {
        const matchesName = customer.name
          .toLowerCase()
          .includes(this.searchQuery);
        const matchesBranch =
          !this.selectedBranch || customer.branch_id === this.selectedBranch;
        return matchesName && matchesBranch;
      });
    },

    currentPagination() {
      if (this.filteredCustomer.length == 0) {
        return {
          page: 1,
          perPage: this.pagination.perPage || 10,
          totalItems: 0,
          totalPages: 0,
          nextPageLink: null,
          previousPageLink: null
        };
      }
      return this.pagination;
    },
  },
  methods: {
    formatDate,
    ...mapActions("customers", ["fetchCustomers", "deleteCustomerById"]),
    ...mapActions("branches", ["fetchBranches"]),

    async fetchCustomers(page = 1, limit = 10) {
      const params = {
        page,
        limit,
        branch_id: this.selectedBranch || "", // Use branch filter
        search: this.searchQuery,
        order: "name",
        sort: "ASC"
      };
      await this.$store.dispatch("customers/fetchCustomers", params);
    },

    handleSearch: debounce(function () {
      // console.log('search query: ', this.searchQuery);
      this.fetchCustomers(1); 
    }, 300),

    getBranchName(branchId) {
      const branch = this.allBranches.find((b) => b.id === branchId);
      return branch ? branch.name : "-";
    },

    filterByBranch() {
      this.fetchCustomers(1);
    },

    showModalAddCustomer() {
      this.customerToEdit = null;
      this.modalShowAddCustomer = true;
    },

    async closeModalAddEditCustomer() {
      this.modalShowAddCustomer = false;
      await this.fetchCustomers();
    },

    showAlertSuccess(text) {
      this.alert_success = true;
      this.alert_text = text;
      setTimeout(() => {
        this.alert_success = false;
      }, 1500);
    },

    openAlert_CustomerCreated() {
      this.showAlertSuccess("Customer added successfully!");
    },

    openAlert_CustomerUpdated() {
      this.showAlertSuccess("Customer updated successfully!");
    },

    deleteCustomer(id) {
      this.customerIdToDelete = id;
      this.showAlertConfirmation();
    },

    editCustomer(customer) {
      this.customerToEdit = customer;
      this.modalShowAddCustomer = true;
    },

    showAlertConfirmation() {
      this.alert_confirmation = true;
    },

    handle_clicked_no() {
      this.alert_confirmation = false;
      this.customerIdToDelete = null;
    },

    async handle_clicked_yes() {
      await this.deleteCustomerById(this.customerIdToDelete);
      this.alert_confirmation = false;
      this.customerIdToDelete = null;
      this.showAlertSuccess("Customer deleted successfully!");
      this.fetchCustomers();
    },
  },
  async created() {
    await this.fetchBranches();
    await this.fetchCustomers(1);
  },
};
</script>
